import axios from "axios";
import { handleError } from "./handleError";
import { getUserToken } from "./helper";

let aux = document.getElementsByClassName("base-url")[0]?.innerText;
const baseUrl = aux?.substring(1, aux.length - 1);

export const axiosInstance = axios?.create({
  baseURL: baseUrl,
  timeout: 180000,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance?.interceptors?.request?.use((options) => {
  options.headers["X-Authorization"] = getUserToken();
  return options;
});

axiosInstance?.interceptors?.response?.use(successfulResponse, handleError);

function successfulResponse(response) {
  return response;
}

//USER
export function loginWithEmailAndPassword(email, password) {
  let body = {
    login: email,
    password,
  };

  return axiosInstance
    ?.post(`/api/wuser/login`, body)
    .then((response) => response?.data);
}

export function updateUserPassword(body) {
  return axiosInstance
    .post("/api/wuser/changePassword", body)
    .then((response) => response.data);
}

export function resetPassword(body) {
  return axiosInstance
    .post("/api/wuser/resetPassword", body)
    .then((response) => response.data)
    .catch((error) => handleError(error));
}

export function requestResetPassword(email) {
  return axiosInstance
    .post(`/api/wuser/requestResetPassword?login=${email}`)
    .then((response) => response?.data)
    .catch((error) => handleError(error));
}

//DESCRIPTORS
export function getSearchTermDescriptor() {
  return axiosInstance
    ?.get("/search-term/definition")
    .then((response) => response?.data);
}

export function getSearchTermByID(id) {
  return axiosInstance
    ?.get(`/search-term/${id}`)
    .then((response) => response?.data);
}

export function getUserDescriptor() {
  return axiosInstance
    .get("/user/definition")
    .then((response) => response?.data);
}

export function getNoteDescriptor() {
  return axiosInstance
    .get("/note/definition")
    .then((response) => response?.data);
}

//URLs GROUPS
export function getUrlGroupDetails(id) {
  return axiosInstance
    ?.get(`url-group/${id}/url/definition`)
    .then((response) => response?.data);
}

export function getUrlGroups() {
  return axiosInstance?.get("/url-group/").then((response) => response?.data);
}

export function getSearchConsoleReport({
  groups,
  periodType,
  startDate,
  endDate,
}) {
  let url = "/url-group/report?";
  if (groups?.length > 0)
    groups?.map((g) => (url = url.concat(`group-id=${g?.id}&`)));
  if (periodType) url = url.concat(`period-type=${periodType}&`);
  if (startDate) url = url.concat(`start=${startDate}&`);
  if (endDate) url = url.concat(`end=${endDate}&`);

  return axiosInstance?.get(url).then((response) => response?.data);
}


export function getNotes({
  startDate,
  endDate,
  type,
  notesOrigin
}) {
  let url = "/note/filter?pageSize=100&";
  if (type) url = url.concat(`type=${type}&`);
  if (startDate) url = url.concat(`startDate=${startDate}&`);
  if (endDate) url = url.concat(`endDate=${endDate}&`);
  if (notesOrigin && notesOrigin !== "TODAS") url = url.concat(`origin=${notesOrigin}&`);

  return axiosInstance?.get(url).then((response) => response?.data);
}
export function getPageSpeedReport({ groups, periodType, startDate, endDate }) {
  let url = "/url-group/pagespeed-report?";
  if (groups?.length > 0)
    groups?.map((g) => (url = url.concat(`group-id=${g?.id}&`)));
  if (periodType) url = url.concat(`period-type=${periodType}&`);
  if (startDate) url = url.concat(`start=${startDate}&`);
  if (endDate) url = url.concat(`end=${endDate}&`);

  return axiosInstance?.get(url).then((response) => response?.data);
}

export function getGroupById(groupId) {
  return axiosInstance
    ?.get(`/url-group/${groupId}`)
    .then((response) => response?.data);
}

export function searchUrlGroup(term = "", page = 0) {
  return axiosInstance
    ?.get(`url-group/filter?term=${term}&page=${page}&pageSize=10`)
    .then((response) => response?.data);
}

//MIGRATION
export function getMigrationsGroups() {
  return axiosInstance
    ?.get(`/url-migration/group/`)
    .then((response) => response?.data);
}

export function getMigrationGroupReport(
  groupID,
  periodType,
  startDate,
  endDate
) {
  let url = "/url-migration/group-report?";
  if (groupID) url = url.concat(`group-id=${groupID}&`);
  if (periodType) url = url.concat(`period-type=${periodType}&`);
  if (startDate) url = url.concat(`start=${startDate}&`);
  if (endDate) url = url.concat(`end=${endDate}&`);

  return axiosInstance?.get(url).then((response) => response?.data);
}

//OTHERS
export function getWebVitalsMetrics() {
  return axiosInstance
    .get(`/pagespeed/limits`)
    .then((response) => response?.data);
}
